<template>
  <div class="quiz-page" v-if="catPage">
    <cat-quiz-item v-if="catPage.is_quiz" :quiz="catPage" />
    <page-item :page="catPage" v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CatQuizItem from './CatQuizItem';
import PageItem from '../../viewer-pages/views/PageItem';

export default {
  name: 'cat-page-show',

  props: [
    'cat',
  ],

  components: {
    CatQuizItem,
    PageItem,
  },

  computed: {
    ...mapGetters({
      catPage: 'getCatPage',
    }),
  },
};
</script>

<style lang="scss" scoped>
  .quiz-page {
    background: #ffffff;
    padding-bottom: 124px;
  }
</style>
